// OLD REST API IMPLEMENTATION - COMMENTED OUT
// export const permissionObjCreator = (module, permissions) => {
//   const permissionsFiltered = permissions.filter((permission) => permission?.module === module);
//
//   // const isEmployee = localStorage.getItem("isEmployee") === "true";
//   const isEmployee = false;
//   const permissionsObj = {};
//
//   // Define each module's special permissions mapping.
//   // Keys are the special_permission value in incoming permissions,
//   // and values are the key that will be added to permissionsObj.
//   const SPECIAL_PERMISSIONS = {
//     sales_book: {
//       edit_invoice: "edit_invoice",
//       convert_to_e_invoice: "convert_to_einvoice",
//     },
//     purchase_book: {
//       edit_invoice: "edit_invoice",
//     },
//     ledger: {
//       report: "report",
//       log_payment: "log_payment",
//     },
//     inventory: {
//       product_crud: "product_crud",
//       batch_crud: "batch_crud",
//     },
//     warehouse: {
//       crud: "crud",
//       top_selling_items: "top_selling_items",
//     },
//     invoice: {
//       create_e_invoice: "create_e_invoice",
//       cancel_invoice: "cancel_invoice",
//       estimate_invoice: "estimate_invoice",
//     },
//     purchase: {
//       create_invoice: "create_invoice",
//       purchase_demand: "purchase_demand",
//       cancel: "cancel",
//     },
//     employee: {
//       disable_profile: "disable_profile",
//       settings: "settings",
//     },
//     settings: {
//       // In some cases special permissions might also include read/update.
//       read: "read",
//       update: "update",
//     },
//   };
//
//   const moduleSpecials = SPECIAL_PERMISSIONS[module] || {};
//
//   // If not employee, grant all common and special permissions for the module.
//   if (!isEmployee) {
//     // Grant all common permissions.
//     permissionsObj.create = true;
//     permissionsObj.read = true;
//     permissionsObj.update = true;
//     permissionsObj.delete = true;
//
//     // Grant every special permission available in this module.
//     Object.values(moduleSpecials).forEach((specialKey) => {
//       permissionsObj[specialKey] = true;
//     });
//
//     return permissionsObj;
//   }
//
//   // For employee, process the provided permissions array.
//   const commonPermissions = (permission) => {
//     if (permission.permission_type === "create") {
//       permissionsObj.create = true;
//     }
//     if (permission.permission_type === "read") {
//       permissionsObj.read = true;
//     }
//     if (permission.permission_type === "update") {
//       permissionsObj.update = true;
//     }
//     if (permission.permission_type === "delete") {
//       permissionsObj.delete = true;
//     }
//   };
//
//   // Iterate through the permissions array.
//   permissionsFiltered.forEach((permission) => {
//     commonPermissions(permission);
//
//     if (permission.permission_type === "special") {
//       const permissionKey = permission.special_permission;
//       if (moduleSpecials[permissionKey]) {
//         permissionsObj[moduleSpecials[permissionKey]] = true;
//       }
//     }
//   });
//
//   return permissionsObj;
// };

// Helper function to extract flattened permissions from GraphQL employee profile
export const extractPermissionsFromEmployee = (employeeProfile) => {
  if (!employeeProfile?.permissions) {
    return [];
  }

  // Get active permission group
  const activePermission = employeeProfile.permissions.find((perm) => perm.isActive);

  if (!activePermission?.group?.permissions) {
    return [];
  }

  // Return the flattened permissions array from the active group
  return activePermission.group.permissions;
};

// Helper function to get current user's permissions from Redux state
export const getCurrentUserPermissions = (userState) => {
  // For non-employee users, return empty array (will get all permissions)
  if (!userState?.employee) {
    return [];
  }

  // Extract permissions from the current user's employee profile
  return extractPermissionsFromEmployee(userState.employee);
};

// NEW GRAPHQL IMPLEMENTATION - LIVE DATA FETCHING
export const permissionObjCreator = (module, permissions, isEmployeeUser = null) => {
  // Convert module name to GraphQL enum format for filtering
  const graphqlModule = module.toUpperCase().replace(/-/g, "_");
  const permissionsFiltered = permissions.filter((permission) => permission?.module === graphqlModule);

  // Determine employee status - prefer passed parameter over localStorage
  const isEmployee = isEmployeeUser !== null ? isEmployeeUser : localStorage.getItem("isEmployee") === "true";
  const permissionsObj = {};

  // Define each module's special permissions mapping.
  // Keys are the specialPermission value in incoming GraphQL permissions,
  // and values are the key that will be added to permissionsObj.
  const SPECIAL_PERMISSIONS = {
    SALES_BOOK: {
      convert_to_e_invoice: "convert_to_einvoice",
      export_data: "export_data",
    },
    PURCHASE_BOOK: {
      export_data: "export_data",
    },
    LEDGER: {
      report: "report",
      log_payment: "log_payment",
    },
    BOOKS_DASHBOARD: {
      export_data: "export_data",
      view_analytics: "view_analytics",
    },
    INVENTORY_DASHBOARD: {
      export_data: "export_data",
      view_analytics: "view_analytics",
    },
    CASH_ENTRY: {
      cash_adjustment: "cash_adjustment",
      view_analytics: "view_analytics",
      export_data: "export_data",
    },
    VOUCHER: {
      breakage_operations: "breakage_operations",
      voucher_history: "voucher_history",
      export_data: "export_data",
    },
    INVENTORY: {
      product_crud: "product_crud",
      batch_crud: "batch_crud",
      category_management: "category_management",
      brand_management: "brand_management",
      unit_management: "unit_management",
      view_analytics: "view_analytics",
      export_data: "export_data",
    },
    WAREHOUSE: {
      crud: "crud",
      top_selling_items: "top_selling_items",
      manage_locations: "manage_locations",
      view_analytics: "view_analytics",
      export_data: "export_data",
      inventory_tracking: "inventory_tracking",
    },
    INVOICE: {
      invoice_operations: "invoice_operations",
      estimate_invoice: "estimate_invoice",
      credit_note: "credit_note",
      debit_note: "debit_note",
      cancel_invoice: "cancel_invoice",
      e_invoice_operations: "e_invoice_operations",
    },
    PURCHASE: {
      stock_purchase_invoice: "stock_purchase_invoice",
      purchase_invoice: "purchase_invoice",
      purchase_demand: "purchase_demand",
      cancel_stock_purchase_invoice: "cancel_stock_purchase_invoice",
      cancel_purchase_invoice: "cancel_purchase_invoice",
    },
    EMPLOYEE: {
      employee_management: "employee_management",
      paystructure_operations: "paystructure_operations",
    },
    // EMPLOYEE_DASHBOARD: {
    //   view_analytics: "view_analytics",
    //   export_data: "export_data",
    // },
    EMPLOYEE_GROUP: {
      group_management: "group_management",
      permission_assignment: "permission_assignment",
    },
    EMPLOYEE_ATTENDANCE: {
      attendance_management: "attendance_management",
    },
    EMPLOYEE_SALARY: {
      download_payslip: "download_payslip",
    },
    EMPLOYEE_SCHEDULE: {
      holiday_management: "holiday_management",
    },
    EMPLOYEE_DEPARTMENT: {
      department_management: "department_management",
      hierarchy_management: "hierarchy_management",
    },
    EMPLOYEE_JOB_POSITION: {
      job_position_management: "job_position_management",
      role_assignment: "role_assignment",
    },
    SETTINGS: {
      // In some cases special permissions might also include read/update.
      read: "read",
      update: "update",
    },
    PL: {
      export_data: "export_data",
      view_tax_pl: "view_tax_pl",
      view_party_pl: "view_party_pl",
      view_company_pl: "view_company_pl",
      view_item_pl: "view_item_pl",
      view_route_pl: "view_route_pl",
      view_analytics: "view_analytics",
    },
    EXPENSE: {
      export_data: "export_data",
      view_analytics: "view_analytics",
      bulk_upload: "bulk_upload",
      category_management: "category_management",
      approve_expenses: "approve_expenses",
      expense_reports: "expense_reports",
    },
    BRAIN_AI: {
      ai_dashboard: "ai_dashboard",
      chatbot: "chatbot",
      simulation: "simulation",
    },
    CRM: {
      bulk_lead_upload: "bulk_lead_upload",
    },
    CRM_DASHBOARD: {
      // View only - no special permissions
    },
    CRM_LEAD: {
      lead_source_management: "lead_source_management",
    },
    CRM_LEAD_TRANSFER: {
      // CRUD only - no special permissions
    },
    CRM_QUOTATION: {
      convert_to_invoice: "convert_to_invoice",
    },
    CRM_PIPELINE: {
      // CRUD only - no special permissions
    },
    CRM_OPEN_TICKETS: {
      note_management: "note_management",
    },
    CRM_LEAD_POOL: {
      random_select: "random_select",
      add_to_crm: "add_to_crm",
    },
  };

  const moduleSpecials = SPECIAL_PERMISSIONS[graphqlModule] || {};

  // For non-employees, only grant permissions if they are actual admin/owner users
  if (!isEmployee) {
    // Non-employees should not automatically get all permissions
    // This will be handled by the calling component based on user role
    return {};
  }

  // For employee, process the provided GraphQL permissions array.
  const commonPermissions = (permission) => {
    // NEW GRAPHQL: Use permissionType instead of permission_type
    if (permission.permissionType === "CREATE") {
      permissionsObj.create = true;
    }
    if (permission.permissionType === "READ") {
      permissionsObj.read = true;
    }
    if (permission.permissionType === "UPDATE") {
      permissionsObj.update = true;
    }
    if (permission.permissionType === "DELETE") {
      permissionsObj.delete = true;
    }
  };

  // Iterate through the permissions array.
  permissionsFiltered.forEach((permission) => {
    commonPermissions(permission);

    // NEW GRAPHQL: Use permissionType and specialPermission
    if (permission.permissionType === "SPECIAL") {
      const permissionKey = permission.specialPermission;
      if (moduleSpecials[permissionKey]) {
        permissionsObj[moduleSpecials[permissionKey]] = true;
      }
    }
  });

  return permissionsObj;
};
